import { Component, OnInit, Inject, OnChanges, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';
import { DOCUMENT } from "@angular/platform-browser";

import { ForumDialogComponent } from '../forum/forum-dialog/forum-dialog.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [AngularFireAuth, AngularFireDatabase]
})
export class NavbarComponent implements OnInit {
  showNav : boolean = false;
  profile : any = {};
  user : any;
  initialScroll : number = 0;
  isSticky : boolean = false;
  shouldHide : boolean = false;

  constructor(public afAuth : AngularFireAuth,
              public dialog : MatDialog,
              private db : AngularFireDatabase,
              private router : Router,
              private el : ElementRef,
              @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;
      if(user) {
        const subscription = this.db.object(`profiles/${user.uid}`)
        .valueChanges().subscribe(snapshot => {
          subscription.unsubscribe();
          Object.assign(this.profile, snapshot);
        })
      }
    })
  }

  logout() {
   this.user = null;
   this.afAuth.auth.signOut();
  }

  toggleNav() {
    this.showNav = !this.showNav;
  }

  newQuestion() {
    let questionDialog = this.dialog.open(ForumDialogComponent, {
      data: {
        user: this.user
      }
    });

    questionDialog.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['discusion', result.ref.key]);
      }
    });
  }

  @HostListener('window:scroll', ['$event']) toggleStickyHeader(event) {
    let delta = 0;
    let newPos = window.scrollY;

    delta = newPos - this.initialScroll;
    this.initialScroll = newPos;

    if (newPos === 0) {
      this.isSticky = false;
      this.shouldHide = false;
    }

    if (newPos > 40) {
      this.isSticky = true;
    }


    if (delta > 0 && newPos > 250) {
      this.shouldHide = true;
    }
    else if (this.isSticky) {
      this.shouldHide = false;
    }
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/navbar/navbar.component.ts